import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

export default function Login() {
  const publicUrl = process.env.PUBLIC_URL || "";
  const { isAuthenticated, login, authLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [focusedField, setFocusedField] = useState("");

  const redirectTo = useMemo(() => {
    const from = location.state?.from;
    if (typeof from === "string" && from.startsWith("/")) {
      return from;
    }
    return "/dashboard";
  }, [location.state]);
  const isEggUsageRedirect = redirectTo.startsWith("/orders/egg-usage-mobile");

  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  const onFocus = (e) => setFocusedField(e.target.name);
  const onBlur = () => setFocusedField("");

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate(redirectTo, { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate, redirectTo]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const { ok, message } = await login(form);
    if (!ok) return setError(message);
    navigate(redirectTo, { replace: true });
  };

  const isInteracting = authLoading || Boolean(focusedField);
  const cardClassName = `login-card${focusedField ? " is-active" : ""}${error ? " is-error" : ""}`;

  return (
    <div className={`login-wrapper${isInteracting ? " is-interacting" : ""}`}>
      <div className="login-bg-decor" aria-hidden="true">
        <span className="login-egg login-egg-1">
          <span className="login-egg-eye login-egg-eye-left" />
          <span className="login-egg-eye login-egg-eye-right" />
        </span>
        <span className="login-egg login-egg-2">
          <span className="login-egg-eye login-egg-eye-left" />
          <span className="login-egg-eye login-egg-eye-right" />
        </span>
        <span className="login-egg login-egg-3">
          <span className="login-egg-eye login-egg-eye-left" />
          <span className="login-egg-eye login-egg-eye-right" />
        </span>
      </div>
      <div className={cardClassName}>
        <div className="login-brand">
          <span className="login-brand-mark" aria-hidden="true">
            <img
              className="login-brand-logo"
              src={`${publicUrl}/haemil-mark.svg`}
              alt=""
            />
          </span>
          <h1 className="login-title">
            <span className="login-title-main">HAEMIL</span>
            <span className="login-title-accent">MES</span>
          </h1>
        </div>
        <form className="login-form" onSubmit={onSubmit}>
          {isEggUsageRedirect ? (
            <div className="login-helper" role="status" aria-live="polite">
              로그인 후 실원란 투입 입력 화면으로 바로 이동합니다.
            </div>
          ) : null}
          <input
            className="login-input"
            name="username"
            value={form.username}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            placeholder="ID"
            autoComplete="username"
          />
          <input
            className="login-input"
            type="password"
            name="password"
            value={form.password}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            placeholder="Password"
            autoComplete="current-password"
          />
          {error && (
            <div className="login-error" role="alert" aria-live="polite">
              {error}
            </div>
          )}
          <button className="btn login-button" type="submit" disabled={authLoading}>
            {authLoading && <span className="login-spinner" aria-hidden="true" />}
            <span>{authLoading ? "로그인 중..." : "로그인"}</span>
          </button>
        </form>
        <p className="login-footer">© 2026 해밀</p>
      </div>
    </div>
  );
}
